import { useState, type FormEvent } from "react";
import { useMeContext } from "../../MeApp";
import { useOnboardingForm } from "../useOnboardingForm";
import { StepShell, StepHeading, RadioCard } from "@codel/dova-ds";
import { Button } from "../components/Button";
import type { StepProps } from "../flowConfig";
import type { ChildrenStatus } from "../../types";
// Options live in `answerVocabulary.ts` — see the note there on why a label may
// not be reworded in place once its key has shipped.
import { CHILDREN_OPTIONS } from "../answerVocabulary";

export function S4cChildren({ onNext, onBack, currentStepIndex, totalSteps }: StepProps) {
  const { couple, partner } = useMeContext();
  const { state, updateAnswers } = useOnboardingForm();
  const otherPartner = couple?.partners.find((p) => p.id !== partner?.id);
  const otherFirstName = otherPartner?.firstName ?? "your partner";

  const [children, setChildren] = useState<ChildrenStatus | null>(state.answers.children);
  const [error, setError] = useState("");

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (!children) {
      setError("Pick one to continue.");
      return;
    }
    setError("");
    updateAnswers({ children });
    onNext();
  };

  return (
    <StepShell
      showBack
      onBack={onBack}
      currentStep={currentStepIndex}
      totalSteps={totalSteps}
      onSubmit={handleSubmit}
      footer={<Button type="submit">Continue</Button>}
    >
      <StepHeading title={`Do you and ${otherFirstName} have children?`} />

      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-4">
          {CHILDREN_OPTIONS.map((opt) => (
            <RadioCard
              key={opt.value}
              name="children"
              value={opt.value}
              label={opt.label}
              checked={children === opt.value}
              onChange={(v) => {
                setChildren(v as ChildrenStatus);
                if (error) setError("");
              }}
            />
          ))}
        </div>
        {error && (
          <p className="text-xs leading-[1.5] text-[var(--danger)]">{error}</p>
        )}
      </div>
    </StepShell>
  );
}
